const STORAGE_KEY = 'prayer-app-settings';

interface LocationSettings {
  governorateId: number;
  delegationId: number;
}

export const saveLocationSettings = (settings: LocationSettings): void => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
};

export const loadLocationSettings = (): LocationSettings | null => {
  const settings = localStorage.getItem(STORAGE_KEY);
  if (!settings) return null;
  
  try {
    return JSON.parse(settings);
  } catch {
    return null;
  }
};

export const clearLocationSettings = (): void => {
  localStorage.removeItem(STORAGE_KEY);
};